@if (isPublicRoute) {
  <router-outlet/>
} @else if (isTheftProtectionAlarmRoute) {
  <router-outlet/>
} @else {
  <osp-dashboard-layout>
    <router-outlet/>
  </osp-dashboard-layout>
  <osp-root-toast/>
  <osp-confirm-dialog key="root-confirm-dialog"/>
}
